// Docs for hubspot forms can be found at
// https://legacydocs.hubspot.com/global-form-events

// Called after form has been inserted into DOM
import { CreateFormConfiguration, HubspotEvents, HubspotGlobalEvents } from '@/services/hubspot/types';

const isFormCallback = (type: HubspotGlobalEvents): boolean => type === HubspotGlobalEvents.FormCallbacks;

export const onFormReady = (cb: Function, event: MessageEvent) => {
  if (isFormCallback(event.data.type) && event.data.eventName === HubspotEvents.FormReady) {
    cb();
  }
};

// Called at the start of form submission, submission hasn't been persisted yet
export const onFormSubmit = (cb: Function, event: MessageEvent) => {
  if (isFormCallback(event.data.type) && event.data.eventName === HubspotEvents.FormSubmit) {
    cb();
  }
};

// Called after the form has been submitted and submission has been persisted
export const onFormSubmitted = (cb: Function, event: MessageEvent) => {
  if (isFormCallback(event.data.type) && event.data.eventName === HubspotEvents.FormSubmitted) {
    cb();
  }
};

export function createHubspotForm(configuration: CreateFormConfiguration): void {
  if (window.hbspt) {
    window.hbspt.forms.create(configuration);
  }
}
